import { useState, useCallback } from 'react';

import formValidation from '../formValidation';
import { INITIAL_FILES_STATE, INITIAL_FORM_STATE, INITIAL_FORM_ERRORS } from '../config';
import { findGroupForTypeId } from '../../../catalog/catalogGroups';

export const useUploadForm = (createUpload, updateUpload, handleCloseModal, materialTypes, catalogGroups = []) => {
    const [form, setForm] = useState(INITIAL_FORM_STATE);
    const [files, setFiles] = useState(INITIAL_FILES_STATE);
    const [errors, setErrors] = useState(INITIAL_FORM_ERRORS);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const handleInputChange = useCallback((name, value) => {
        setForm((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    }, []);

    const handleFileChange = useCallback((name, value) => {
        setFiles((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    }, []);

    const resetForm = useCallback((defaults = {}) => {
        setForm({ ...INITIAL_FORM_STATE, ...defaults });
        setFiles(INITIAL_FILES_STATE);
        setErrors(INITIAL_FORM_ERRORS);
        setIsEdit(false);
        setSelectedItem(null);
    }, []);

    const setEditData = useCallback((item) => {
        setIsEdit(true);
        setSelectedItem(item);

        const formatDateForInput = (dateString) => {
            if (!dateString) return '';
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';
            return date.toISOString().split('T')[0];
        };
        const materialType = (materialTypes || []).find((type) => type.id === item?.material_type_id);
        const group = findGroupForTypeId(catalogGroups, materialType?.id || item?.material_type_id);
        setForm({
            title: item?.title,
            description: item?.description,
            date: formatDateForInput(item?.date),
            url: item?.url,
            catalog_group_id: group?.id || '',
            material_type_id: materialType?.id || item?.material_type_id || ''
        });
        setErrors(INITIAL_FORM_ERRORS);
        setFiles(INITIAL_FILES_STATE);
    }, [materialTypes, catalogGroups]);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        const isValid = formValidation(form, isEdit, files, setErrors, materialTypes);
        if (!isValid) {
            return;
        }

        const formData = new FormData();
        formData.append('date', form.date);
        formData.append('title', form.title);
        formData.append('description', form.description);
        formData.append('material_type_id', form.material_type_id);

        if (files.manual) {
            formData.append('manual', files.manual);
        }
        if (files.thumbnail) {
            formData.append('thumbnail', files.thumbnail);
        }
        if (form.url) {
            formData.append('url', form.url);
        }
        if (isEdit) {
            formData.append('id', selectedItem?.id);
            updateUpload(formData, {
                onSuccess: () => {
                    handleCloseModal();
                }
            });
        } else {
            createUpload(formData, {
                onSuccess: () => {
                    handleCloseModal();
                }
            });
        }
    }, [form, files, isEdit, selectedItem, updateUpload, createUpload, handleCloseModal, materialTypes]);

    return {
        form,
        files,
        errors,
        isEdit,
        selectedItem,
        handleInputChange,
        handleFileChange,
        resetForm,
        setEditData,
        handleSubmit
    };
};
